import { LayerType } from '@meitu/saas-editor-core/es/version-types';
import BackgroundPanel from './views/background-panel/background-panel';
import BrushPanel from './views/brush-panel/brush-panel';
import ChartPanel from './views/chart-panel/chart-panel';
import GroupPanel from './views/group-panel/group-panel';
import ImagePanel from './views/image-panel/image-panel';
import MarkupPanel from './views/markup-panel/markup-panel';
import MediaPanel from './views/media-panel/media-panel';
import QRCodePanel from './views/qr-code-panel/qr-code-panel';
import TablePanel from './views/table-panel/table-panel';
import TextArtPanel, { TextArtPanelKey } from './views/text-art-panel/text-art-panel';
import TextMarkPanel, { TextMarkPanelKey } from './views/text-mark-panel/text-mark-panel';
import TextPanel from './views/text-panel/text-panel';
import VectorPanel from './views/vector-panel/vector-panel';

// import WatermarkPanel from './views/watermark-panel/watermark-panel';

export const panelConf: Record<string, React.ReactNode> = {
    [LayerType.TEXT_LAYER]: <TextPanel />,
    [LayerType.IMAGE_LAYER]: <ImagePanel />,
    [LayerType.GROUP_LAYER]: <GroupPanel />,
    [LayerType.BACKGROUND_LAYER]: <BackgroundPanel />,
    [LayerType.VECTOR_LAYER]: <VectorPanel />,
    [LayerType.QR_CODE]: <QRCodePanel />,
    [LayerType.TABLE]: <TablePanel />,
    [LayerType.BRUSH_LAYER]: <BrushPanel />,
    [LayerType.WATERMARK]: <div />,
    [LayerType.MARKUP_LAYER]: <MarkupPanel />,
    [LayerType.MEDIA_LAYER]: <MediaPanel />,
    [LayerType.CHART]: <ChartPanel />,
    [TextMarkPanelKey]: <TextMarkPanel />, // 划重点面板
    [TextArtPanelKey]: <TextArtPanel />, // 花字面板
};
